import Hokej from './Hokej'

const Vaterpolo = () => <Hokej calculatorType='Vaterpolo' />

export default Vaterpolo
